<template>

  <div>
      <div>
          <Button type="primary"  @click="picModal = true">
              新增图片
          </Button>

      </div>
      <div class="picList" style="text-align: center;">
           <div v-for="(item,index) in picList ">
               <div style="width: 200px;height: 200px;">  <img :src="item.imgPath" alt="" class="pic"></div>
                  <div> {{item.name}}</div>
                <div> <Button class='delBtn' type="error" @click='delPic(item.id)'>删除</Button></div>

           </div>

      </div>
   <Modal
           v-model="picModal"
           title="图片上传"
           @on-ok="handleSubmit"
           @on-cancel="cancel">
           <Input v-model="picName" placeholder="填写图片名称" style="width: 300px" />
           <div style="margin-top: 20px;">
             <Upload
                     multiple
                     type="drag"
                      :on-success='hasPic'
                    :show-upload-list="true"
                    :format="['jpg','jpeg','png']"
                    :on-format-error="handleFormatError1"
                     :headers="upHeaders"
                     action="https://api.caoshalove.top/mark/picture/add">

                     <div style="padding: 20px 0">
                         <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                         <p>点击或者拖拽上传图片</p>
                     </div>
                 </Upload>

           </div>
       </Modal>
  </div>
</template>

<script>
import axios from 'axios';
import QS from "qs"
  export default{
    			created(){  //生命周期里接收参数
  console.log(this.baseURL )
                this.getPic()
    	},
    	data(){
    		 return {
    			 name:'',
           picModal:false,
           picName:'',
    			 pas:'',
    			 code:'',
    			 show:false,
            picList:[],
          imgFile:'',
    			 ad:'',
					 upHeaders:''
    			 }
    	},
    	methods:{
    		   getPic() {
                         var params = { }
           this.upHeaders={
						  "token":sessionStorage.getItem('token'),
               "type":sessionStorage.getItem('type')
					 }
                      	 this.post('apis/mark/picture/get',
                         ).then(res => {
                          	console.log(res)
                            this.picList = res.data

                          }).catch(err => {             //
                            console.log(err)
                          });


                  },
                  delPic(e){
                    console.log(e)
                    var params = {
                      id:e
                    }

                    this.post('apis/mark/picture/delete',params
                    ).then(res => {
                     	console.log(res)
                         this.getPic()

                     }).catch(err => {             //
                       console.log(err)
                     });
                  },
                  hasPic(e){
										console.log(e)
                    console.log(e.data)
                    if(e.status == 1){
											  console.log(this.imgFile)
                      this.imgFile  = 'https://img.caoshalove.top' + e.data
                    }
                     console.log(this.imgFile)
                  },


                            handleSubmit () {

                                  var params = {
                                    path:this.imgFile,
                                    name:this.picName
                                  }

                                   this.post('apis/mark/picture/addImg',params)
                                   .then(data=>{
                                     console.log(data)
                                       if(data.status==1){
                                           this.$Message.success('添加成功');
                                           this.picName = ' '
                                             this.imgFile = ' '
                                           this.getPic()
                                       }else{
                                           this.$Message.error('添加失败')
                                       }
                                   }).catch(err=>{
                                       console.log(err.message)
                                   })
                             },




              }

    }



</script>

<style>
  .picList{
    padding: 20px 0;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
  }
  .pic{
    width:200px;
    height: 200px;
  }
  .delBtn{
    display: block;
    margin:  20px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/pic.vue